<template>
    <v-card
      class="mx-auto mt-6 d-flex flex-column elevation-0"
      width="300"
      variant="outlined"
    >
      <v-img
          class="image"
          width="300"
          :src="require(`@/assets/AdobeStock_Mikhaylovskiy.jpeg`)"
          :alt="`Hormonal Contraception`"
      ></v-img>
      <div class="d-flex flex-column align-start">
        <v-card-text class="font-weight-bold py-0" style="font-size: 1.2rem;">
          PCOS und Endometriose im Vergleich
        </v-card-text>
        <v-card-text class="text-justify pt-1 font-weight-medium" style="font-size: 1.1rem; line-height: 150%;">
          Falls du dich gefragt hast, welche Unterschiede es gibt, findest du hier mehr Informationen.
        </v-card-text>
      </div>
    </v-card>
  </template>
  
  <script>
    export default {
      name:"PCOS"
    }
  </script>
  
  <style>
  .image{
    margin-bottom: 16px !important;
    height: 170px;
  }
  .image img{
    object-fit: cover;
    height: 170px;
  }
  </style>
  
  